// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3fohu","copyright":"Footer_copyright__1aN2V"};